export default __webpack_public_path__ + "locales/pl/ChangeUserTypeDialog.json?hash=057355638436c20e008f47daab433c77";